/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { institutionsAPI } from 'src/api/modules/institutions';
import { organsAPI } from 'src/api/modules/organs';
import { profilesAPI } from 'src/api/modules/profiles';
import UtilInputs from 'src/common/components/UtilInputs';
import { labelsformCounsel, labelOrgans } from '../utils/list_data';
import ExistingUserModal from './ExistingUserModal';
import { usersAPI } from 'src/api/modules/users';
import notice from 'src/common/components/Notice';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import SimpleDropdown from 'src/common/components/SimpleDropdown';
import CustomButton from 'src/common/components/CustomButton';
import { Grid } from '@material-ui/core';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';

const AdviserUserTab = ({
	form,
	handleChange,
	disableForm,
	myProfile,
	isEdit,
	addOrgans,
	disableOrgan,
	assignOrgans,
	member,
	//onHandleMember,
	handleAddOrgan,
	onDelete,
	setFlagOrgans,
}) => {
	const [organs, setOrgans] = useState([]);
	const [institutions, setInstitutions] = useState([]);
	const [profiles, setprofiles] = useState([]);
	const { user } = useSelector((state) => state.auth);
	const [existingUserModal, setExistingUserModal] = useState(false);
	const [nameUser, setNameUser] = useState();

	useEffect(() => {
		getOrgans();
		getInstitutions();
		getProfiles();
	}, []);

	const getProfiles = () => {
		profilesAPI
			.get('get')
			.then((response) => {
				if (response && response.length > 0) {
					let profilesFlag = [];
					response.forEach((ele) => {
						profilesFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setprofiles([...(profilesFlag || [])]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getInstitutions = () => {
		institutionsAPI
			.get('organizacion')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...(institutionsFlag || [])]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getOrgans = () => {
		organsAPI
			.get('get')
			.then((response) => {
				if (response && response.length > 0) {
					setOrgans(getAllOrgans(response));
					setFlagOrgans(getAllOrgans(response));
				}
			})
			.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
	};

	const getDataFileMinos = () => {
		const identidad = form.id === undefined ? 0 : form.id;
		let nameFile = '';
		if (form.id !== undefined && form.archivos !== undefined) {
			nameFile =
				form.archivos.length === 0
					? ''
					: form.archivos[form.archivos.length - 1].nombre;
		}
		const data = {
			idEntidad: identidad,
			tipo: 'O',
			entidad: 'USUARIOS',
			ruta: 'Usurios/Oficio/' + identidad + '/',
			title: 'Archivo Oficio',
			nombre: nameFile,
			nombreUsuario:
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
			typeDownload: 'campo Archivo Oficio del usuario ' + form.usuario,
		};

		return data;
	};

	const getUserIS = (event) => {
		let validacion = false;

		const { name } = event.currentTarget;

		if (name === 'nombre') validacion = true;
		if (name === 'apellidoPaterno') validacion = true;
		if (name === 'apellidoMaterno') validacion = true;

		if (isEdit === true) validacion = false;

		if (validacion === true) {
			if (form.nombre !== '' && form.apellidoPaterno !== '') {
				setNameUser(
					form.nombre.trimEnd() +
						' ' +
						form.apellidoPaterno.trimEnd() +
						' ' +
						form.apellidoMaterno.trimEnd()
				);

				usersAPI
					.get(
						'predictivo?nombre=' +
							form.nombre.trimEnd() +
							' ' +
							form.apellidoPaterno.trimEnd() +
							' ' +
							form.apellidoMaterno.trimEnd() +
							'&conorganos=false'
					)
					.then((response) => {
						if (response.length > 0) {
							setExistingUserModal(true);
							handleChange({ target: { name: 'usuario', value: '' } });
						} else getIS();
					})
					.catch((e) =>
						notice('Ocurrio un error al verificar usuarios existentes')
					);
			}
		}
	};

	const getIS = () => {
		setExistingUserModal(false);
		let data = {
			nombre: form.nombre,
			apellidoPaterno: form.apellidoPaterno,
			apellidoMaterno: form.apellidoMaterno,
		};

		usersAPI
			.getUserEXT(data)
			.then((response) => {
				handleChange({ target: { name: 'usuario', value: response.usuario } });
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	return (
		<>
			<UtilInputs
				formValues={form}
				inputValues={labelsformCounsel(
					institutions,
					disableForm,
					myProfile,
					getDataFileMinos(),
					profiles,
					disableOrgan,
					member.member
				)}
				onValuesChange={handleChange}
				onBlur={getUserIS}
			/>
			{/* <UtilInputs
				formValues={member}
				inputValues={[
					{
						label: `${
							member.member ? 'Miembro' : 'Integrante de Órgano Colegiado'
						}`,
						name: 'member',
						type: 'checkbox',
						column: 12,
						autoComplete: 'off3',
						value: member.member,
					},
				]}
				onValuesChange={onHandleMember}
			/> */}
			<h6 className={assignOrgans ? 'my-3 ml-lg-3 mb-4' : 'd-none'}>
				Asignación de Órganos Colegiados
			</h6>

			{!member.member && assignOrgans && (
				<UtilInputs
					formValues={addOrgans}
					inputValues={labelOrgans(organs, disableOrgan)}
					onValuesChange={handleChange}
				/>
			)}
			{member.member && assignOrgans && addOrgans.organs && (
				<Grid container>
					<Grid item xs={12} md={5}>
						<h8 className="ml-lg-3">Órgano Colegiado</h8>
					</Grid>
					<Grid item xs={12} md={5}>
						<h9 className="ml-lg-4">Cargo</h9>
					</Grid>
				</Grid>
			)}
			{member.member &&
				assignOrgans &&
				addOrgans.organs &&
				addOrgans.organs.map((item, index) => (
					<div key={index}>
						<Grid container spacing={1} className="ml-lg-2">
							<Grid item xs={12} md={5}>
								<SimpleDropdown
									options={organs}
									value={item.value}
									onChange={(e) => handleChange(e, 'tree', index)}
								/>
							</Grid>
							<Grid item xs={12} md={5}>
								<SimpleDropdown
									options={[
										{ value: 'PR', text: 'Propietario' },
										{ value: 'SU', text: 'Suplente' },
									]}
									onChange={(e) => handleChange(e, 'cargo', index)}
									value={item?.cargo?.toString()?.toUpperCase() || ''}
								/>
							</Grid>
							<Grid container item xs={12} md={2} spacing={1}>
								<Grid item xs={12}>
									<TrashIcon onClick={() => onDelete(item.value)} />
								</Grid>
							</Grid>
						</Grid>
					</div>
				))}
			{member.member && assignOrgans && addOrgans.organs && (
				<Grid container item xs={3} mt={4}>
					<CustomButton
						style={{
							width: '100%',
							height: '100%',
							marginTop: '8px',
							marginLeft: '11px',
						}}
						mainText="Agregar"
						color="info"
						onClick={handleAddOrgan}
					/>
				</Grid>
			)}
			<ExistingUserModal
				open={existingUserModal}
				setOpen={setExistingUserModal}
				nameUser={nameUser}
				onCreate={getIS}
			/>
		</>
	);
};

export default AdviserUserTab;
